import { render, staticRenderFns } from "./giftComplete.vue?vue&type=template&id=a5e4d34e&scoped=true"
import script from "./giftComplete.vue?vue&type=script&lang=js"
export * from "./giftComplete.vue?vue&type=script&lang=js"
import style0 from "./giftComplete.vue?vue&type=style&index=0&id=a5e4d34e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e4d34e",
  null
  
)

export default component.exports